import React, { useState } from 'react';
import toast from 'react-hot-toast';

const ContactSection = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const contactInfo = [
    {
      icon: 'fas fa-phone',
      title: 'Phone',
      details: '+91 9187458799',
      subDetails: '+91 9187458798'
    },
    {
      icon: 'fab fa-whatsapp',
      title: 'WhatsApp',
      details: '+91 9187458799',
      subDetails: 'Quick response guaranteed'
    },
    {
      icon: 'fas fa-envelope',
      title: 'Email',
      details: 'truehomeproperties.co.in@gmail.com',
      subDetails: 'We reply within 24 hours'
    },
    {
      icon: 'fas fa-globe',
      title: 'Website',
      details: 'www.truehomeproperties.co.in',
      subDetails: 'Visit our online portal'
    },
    {
      icon: 'fas fa-map-marker-alt',
      title: 'Address',
      details: 'H.K Complex, Lakkenahalli Main Road',
      subDetails: 'Jyothinagara, Madanayakanahalli, Bengaluru- 562123'
    }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Validate required fields
      if (!formData.name || !formData.email || !formData.message) {
        toast.error('Please fill in all required fields.');
        setIsSubmitting(false);
        return;
      }

      // Create WhatsApp message
      const whatsappMessage = `*New Contact Form Submission*

*Name:* ${formData.name}
*Email:* ${formData.email}
*Phone:* ${formData.phone || 'Not provided'}
*Subject:* ${formData.subject || 'General Inquiry'}

*Message:*
${formData.message}

---
Sent from TrueHome Properties Website`;

      // WhatsApp number (using your first phone number)
      const whatsappNumber = '919187458799';
      
      // Create WhatsApp URL
      const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
      
      // Simulate processing delay
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Open WhatsApp
      window.open(whatsappURL, '_blank');
      
      toast.success('Redirecting to WhatsApp... Your message will be sent there.');
      
      // Reset form after successful submission
      setTimeout(() => {
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      }, 2000);
      
    } catch (error) {
      toast.error('Failed to process message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-luxhom" aria-labelledby="contact-heading">
      <div className="container">
        <header 
          className="section-header-luxhom"
        >
          <div className="section-badge-luxhom">GET IN TOUCH</div>
          <h2 id="contact-heading">Contact Our Expert Team</h2>
          <p>
            Ready to find your dream property across Karnataka, Goa, Andhra Pradesh, Tamil Nadu, Pune, or Mumbai? 
            Our luxury real estate specialists are here to help you every step of the way. Let's start the conversation today.
          </p>
        </header>

        <div className="contact-content-luxhom">
          <address 
            className="contact-info-luxhom"
          >
            <h3>Let's Connect</h3>
            <p>
              Our team of luxury real estate experts is here to help you find the 
              perfect property across India or answer any questions you may have.
            </p>

            {contactInfo.map((item, index) => (
              <div
                key={index}
                className={`contact-item-luxhom ${item.title === 'WhatsApp' ? 'clickable' : ''}`}
                onClick={item.title === 'WhatsApp' ? () => {
                  const whatsappURL = `https://wa.me/919187458799?text=${encodeURIComponent('Hi! I found your contact on TrueHome Properties website. I would like to inquire about your real estate services across Karnataka, Goa, Andhra Pradesh, Tamil Nadu, Pune, and Mumbai.')}`;
                  window.open(whatsappURL, '_blank');
                } : undefined}
                style={item.title === 'WhatsApp' ? { cursor: 'pointer' } : {}}
                role={item.title === 'WhatsApp' ? 'button' : undefined}
                tabIndex={item.title === 'WhatsApp' ? 0 : undefined}
                aria-label={item.title === 'WhatsApp' ? 'Contact us via WhatsApp' : undefined}
              >
                <div className="contact-icon-luxhom" aria-hidden="true">
                  <i className={item.icon}></i>
                </div>
                <div className="contact-details-luxhom">
                  <h4>{item.title}</h4>
                  <p>{item.details}</p>
                  <p>{item.subDetails}</p>
                </div>
              </div>
            ))}
          </address>

          <div 
            className="contact-form-luxhom"
          >
            <h3>Send us a Message</h3>
            <p>Fill out the form below and it will be sent directly to our WhatsApp for instant response</p>

            <form onSubmit={handleSubmit}>
              <div className="form-row-luxhom">
                <div className="form-group-luxhom">
                  <input
                    type="text"
                    placeholder="Your Name *"
                    className="input-luxhom"
                    value={formData.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    required
                  />
                </div>
                
                <div className="form-group-luxhom">
                  <input
                    type="email"
                    placeholder="Your Email *"
                    className="input-luxhom"
                    value={formData.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="form-row-luxhom">
                <div className="form-group-luxhom">
                  <input
                    type="tel"
                    placeholder="Phone Number"
                    className="input-luxhom"
                    value={formData.phone}
                    onChange={(e) => handleInputChange('phone', e.target.value)}
                  />
                </div>
                
                <div className="form-group-luxhom">
                  <select 
                    className="input-luxhom"
                    value={formData.subject}
                    onChange={(e) => handleInputChange('subject', e.target.value)}
                  >
                    <option value="">Select Subject</option>
                    <option value="buying">Buying Property</option>
                    <option value="selling">Selling Property</option>
                    <option value="renting">Renting Property</option>
                    <option value="investment">Investment Consultation</option>
                    <option value="other">Other Inquiry</option>
                  </select>
                </div>
              </div>

              <div className="form-group-luxhom">
                <textarea
                  placeholder="Your Message *"
                  rows="6"
                  className="input-luxhom"
                  value={formData.message}
                  onChange={(e) => handleInputChange('message', e.target.value)}
                  required
                ></textarea>
              </div>

              <button 
                type="submit" 
                className="btn-luxhom"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <div className="loading-luxhom"></div>
                    <span>Processing...</span>
                  </>
                ) : (
                  <>
                    <i className="fab fa-whatsapp"></i>
                    <span>Send via WhatsApp</span>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;